import { EPaymentCategory } from '@/enums/ECustomerType';
import { ECustomerStatus } from '../enums/ECustomerStatus';
import { IColor } from '../interfaces/color';

const getCustomerName = (status: ECustomerStatus): string => {
  switch (status) {
    case ECustomerStatus.ACTIVE:
      return 'Active';
    case ECustomerStatus.BACKLIST:
      return 'Backlist';
  }
};

const getCustomerStatus = (status: ECustomerStatus): IColor => {
  let color: IColor = {
    bg: 'bg-gray-200',
    text: 'text-black',
  };
  switch (status) {
    case ECustomerStatus.ACTIVE:
      color = {
        bg: 'bg-green-100',
        text: 'green',
      };
      break;
    case ECustomerStatus.BACKLIST:
      color = {
        bg: 'bg-red-100',
        text: 'red',
      };
      break;
  }
  return color;
};

const getPaymentCategoryName = (category: EPaymentCategory): string => {
  switch (category) {
    case EPaymentCategory.DELIVERY_WITH_BILLING_BANK_TRANSFER:
      return 'ส่งของพร้อมวางบิล + โอนเงิน';
    case EPaymentCategory.DELIVERY_WITH_BILLING_CHEQUE:
      return 'ส่งของพร้อมวางบิล + รับเช็ค';
    case EPaymentCategory.COLLECTOR_WITH_BILLING_BANK_TRANSFER:
      return 'Collector วางบิล + โอนเงิน';
    case EPaymentCategory.COLLECTOR_WITH_BILLING_CHEQUE:
      return 'Collector วางบิล + รับเช็ค';
    default:
      return '';
  }
};

const getPaymentCategoryOptions = () =>
  Object.entries(EPaymentCategory)
    .filter(([key]) => isNaN(Number(key)))
    .map(([, value]) => ({
      label: getPaymentCategoryName(value as EPaymentCategory),
      value: value as EPaymentCategory,
    }));

export {
  getCustomerName,
  getCustomerStatus,
  getPaymentCategoryName,
  getPaymentCategoryOptions,
};
